import { createStyles } from '@mantine/core';

export const useNoteStyles = createStyles((theme) => ({
  accordionContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    padding: `${theme.other.spacing._16}px ${theme.other.spacing._8}px`,
    backgroundColor: theme.white,
    borderRadius: theme.other.spacing._8,
    border: `1px solid ${theme.colors.gray2[0]}`,
  },
}));
